export default "__VITE_ASSET__14ru6tpl__"